import Components from './Components'

export default {
  ...Components
}
